<ng-container [ngSwitch]="true">
  <div *ngSwitchCase="''">
    
  </div>
  <div *ngSwitchDefault><NS-headermenu></NS-headermenu></div>
</ng-container>
